import EditTestimonyContainer from "../containers/EditTestimonyContainer";

const EditTestimonyPage = () => {
  return (
    <EditTestimonyContainer />
  );
};

export default EditTestimonyPage;
